// Vendor Imports
import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const currentUser = localStorage.getItem('currentUser');
    const user = JSON.parse(currentUser);
    if(user.roleId && user.roleId ==1){
     console.log('Url',state.url);
     let Url=state.url;
     if(state.url=='/Forms&Applications'){
      Url='Forms And Application'.toLowerCase().replace(/\s+/g, '')
     }
     else if(state.url=='/Help Desk'){
      Url='helpdesk'.toLowerCase().replace(/\s+/g, '')
     }
     else {
      Url=state.url.substring(1).toLowerCase();
     }

     const moduleList = user && user.moduleList ? user.moduleList : [];
      let moduleLists=moduleList.filter((x)=>x.isActive).map((value)=>value.moduleName.toLowerCase().replace(/\s+/g, ''));
      console.log(moduleLists);
      moduleLists.push('members');
      moduleLists.push('manageusertype');
      moduleLists.push('reset-password');
      moduleLists.push('dashboard');
      moduleLists.push('admin-profile');
      moduleLists.push('reset-password');
      console.log('Orginal Url',Url);
      if(moduleLists.includes('helpdesk')){
      moduleLists.push('technician');
      }
      if (moduleLists.includes('vendor')){
        moduleLists.push('vendorgroup');

      }
     console.log(moduleLists.includes(Url));
      if(!moduleLists.includes(Url)){
        // this.router.navigate([state.url]);
       this.router.navigate(['/login']); // Redirect to default page if user's role is not allowed
        return false;
      }
      // this.router.navigate(['/login']);
      // return;
      // if(!moduleLists.includes(Url)){
      //   this.router.navigate(['/members']); // Redirect to default page if user is not authorized
      //   return false;
      // }
    }
    if (currentUser) {
      
      const isAuthorized = user && user.roleId;
      
      if (!isAuthorized) {
        this.router.navigate(['/login']); // Redirect to default page if user is not authorized
        return false;
      }
      

      const allowedRoles = route.data.allowedRoles as Array<number>;
      if (allowedRoles && allowedRoles.indexOf(user.roleId) === -1) {
        if(user.roleId==1){
        
        this.router.navigate(['/members']); // Redirect to default page if user's role is not allowed
        return false;
        }
        else{
          const moduleList = user && user.moduleList ? user.moduleList : [];
          let moduleLists=moduleList.filter((x)=>x.isActive).map((value)=>value.moduleName);
          console.log(moduleLists);
        this.router.navigate(['/organization']); // Redirect to default page if user's role is not allowed
        return false;
        }
      }

      // User is logged in and authorized
      return true;
    }

    // Not logged in so redirect to login page
    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
